module.exports = __webpack_public_path__ + "static/media/toolbar-full-screen.18b07668.svg";